import Table from 'react-bootstrap/Table'

import { getClassSectionSchedule } from '../DataAndAPIs/ClassSections'
import { CSTDate, incrementDate, sprintStartDate, sprintEndDateWithoutTime } from './SprintDates'
import { getClassTitle } from '../DataAndAPIs/ClassSections'
import { internalLink } from '../DataAndAPIs/Links'
import { getSlideDecksFromClassSection } from '../DataAndAPIs/ClassSections'
import { sprintStartDateRaw } from './SprintDates'

// The renderSchedule function is used to render the sprint schedule for a given class section and sprint. 
export const renderSchedule = (classSectionID, sprint) => {
	const slideDeckLink = (sprint, sessionNumber, activity) => { 
		const slideDecks = getSlideDecksFromClassSection()
		if (slideDecks && (sessionNumber <= slideDecks[sprint-1].length) && (slideDecks[sprint-1][sessionNumber-1] !== null)) {
			return internalLink(activity, `/slide/${classSectionID}/${sprint}/${sessionNumber}/1`)
		}
		return activity
	}

	const renderCourseScheduleTableBody = (sprint) => {
		const sprintSchedule = getClassSectionSchedule(sprint)
		let sessionNumber = 0
		return sprintSchedule.map((currentSchedule, index) => {
			const { day, activity } = currentSchedule
			const sprintStartDateRawFormat = sprintStartDateRaw(sprint-1)
			const date = incrementDate(new Date(sprintStartDateRawFormat), day)
			sessionNumber++

			return (<tr key={index}><td>{CSTDate(date, false, false)}</td><td>{slideDeckLink(sprint, sessionNumber, activity)}</td></tr>)
		})
	}

	return (<div>
		<h4>{getClassTitle()}</h4>
		<p>Sprint {sprint} starts <em>{sprintStartDate(sprint-1)}</em> and ends <em>{sprintEndDateWithoutTime(sprint-1)}</em></p>
		<Table striped bordered hover>
			<thead><tr><th style={{ width: '28%' }}>Daten</th><th>Activities</th></tr></thead>
			<tbody>
				{renderCourseScheduleTableBody(sprint)}
			</tbody>
		</Table>
	</div>)
}